import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tab from '../../common/tab';
import { getQueryParams, isNotLoginOrExpired } from '../../helpers/Common';
import Const from './Const';
import Contribution from './contribution';
import Foreign from './foreign/Foreign';
import Proprietary from './proprietary/Proprietary';
import './money-flow.scss';
import { changeComGroupCodeProprietary } from './reducer';
import ScrollComponent from './../../common/ScrollComponent';
import { compose } from 'redux';
import currentState from './../../helpers/CurrentState';
import ConstCommon from './../../common/Const';
import { COMPONENT_RESIZE } from '../../common/GoldenLayoutWrapper';

const TABS = {
  CONTRIBUTION: 1,
  FOREIGN: 2,
  PROPRIETARY: 3,
};

const mapQueryTab = {
  contribution: TABS.CONTRIBUTION,
  foreign: TABS.FOREIGN,
  proprietary: TABS.PROPRIETARY,
};

class MainContent extends Component {
  constructor(props) {
    super(props);
    const tabFromQuery = mapQueryTab[getQueryParams('tab')];
    this.state = {
      widthScroll: 1,
      currentTab:
        tabFromQuery ||
        props.tab ||
        currentState.get(ConstCommon.listComponent.MoneyFlow, 'currentTab') ||
        TABS.CONTRIBUTION,
    };
    this.scrollRef = React.createRef();
  }

  changeTab = currentTab => {
    const { changeComGroupCode } = this.props;
    if (currentTab === TABS.PROPRIETARY) {
      changeComGroupCode(Const.listFilterByOrganCode.VNINDEX.key);
    }
    currentState.add(
      ConstCommon.listComponent.MoneyFlow,
      'currentTab',
      currentTab,
    );
    this.setState({ currentTab });
  };

  changeWidthScroll = () => {
    if (this.scrollRef.current) {
      this.setState({ widthScroll: this.scrollRef.current.scrollWidth });
    }
  };

  componentDidMount() {
    const { currentTab } = this.state;
    const { user } = this.props;
    if (isNotLoginOrExpired(user) && currentTab === TABS.PROPRIETARY) {
      this.setState({
        currentTab: TABS.CONTRIBUTION,
      });
    }
    this.changeWidthScroll();
    window.addEventListener(COMPONENT_RESIZE, this.changeWidthScroll);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.widthScroll !== this.scrollRef.current.scrollWidth) {
      this.changeWidthScroll();
    }
  }

  componentWillUnmount() {
    window.removeEventListener(COMPONENT_RESIZE, this.changeWidthScroll);
  }

  render() {
    const { currentTab } = this.state;

    return (
      <div className="money-flow-wrapper">
        <div className="top-nav">
          <div
            className="px-20 sticky"
            style={{ width: this.state.widthScroll }}
          >
            <Tab
              currentTab={currentTab}
              listTab="moneyFlowCommon.tab"
              changeTab={this.changeTab}
            />
          </div>
        </div>
        <ScrollComponent>
          <div className="top-nav d-flex flex-column flex-fill h-100">
            <div
              className="tab-content flex-fill d-flex flex-column h-auto"
              ref={this.scrollRef}
            >
              {currentTab === TABS.CONTRIBUTION && <Contribution />}
              {currentTab === TABS.FOREIGN && <Foreign />}
              {currentTab === TABS.PROPRIETARY && <Proprietary />}
            </div>
          </div>
        </ScrollComponent>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.userInfo,
});

const mapDispatchToProps = {
  changeComGroupCode: changeComGroupCodeProprietary,
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(MainContent);
